import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const BehaviourTherapy = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Behaviour Therapy
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex max-w-fit'>
              <p className='text-black sm:text-justify md:text-xl'>
                Ideal for children aged 2 to 18, our behaviour therapy programs
                teaches families customized strategies on how to manage, enhance
                and maximize the adaptive and executive functioning efficiency
                of children with autism, ADHD and other learning disabilities.
                Led by an experienced behaviour therapist specializing in
                working with children with special needs, behaviour therapy
                teaches your child how to behave safely and appropriately at
                home, in the community and in a school setting while also
                developing age appropriate social etiquette to allow your child
                to develop suitable social group skills. Children’s executive
                functioning skills are pinpointed and enhanced along with
                developing strategies to help with their emotional regulation.
                Both FSCD vendor direct pay and private pay options are
                available.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/behaviourtherapy.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BehaviourTherapy;
